import { defineProvider } from '@nuxt/image/runtime';

export default defineProvider({
  getImage(src: string, { modifiers } = {}) {
  const { width, height, format, fit, ...providerModifiers } = modifiers;

  let url = src;
  const params = [];
  if (width) {
    params.push(`w=${width}`);
  }
  if (height) {
    params.push(`h=${height}`);
  }
  if (providerModifiers?.quality) {
    params.push(`q=${providerModifiers.quality}`);
  }

  if (fit) {
    switch (fit) {
      case 'cover':
        params.push('mode=max');
        break;

      case 'contain':
        params.push('mode=crop');
        break;

      case 'fill':
        params.push('mode=stretch');
        break;

      case 'inside':
      case 'outside':
        params.push('mode=pad');
        break;
    }

  }

  if (providerModifiers?.format) {
    params.push(`f=${providerModifiers.format}`);
  } else if (format) {
    params.push(`f=${format}`);
  }
  if (params.length) {
    url += '?' + params.join('&');
  }

    return {
      url,
    };
  },
});
